import React, { CSSProperties, useEffect, useRef, useState } from 'react';
import { Container, DropContainer } from './style';

export interface DropdownButtonProps {
  disabled?: boolean;
  tooltip?: string;
  children: JSX.Element | JSX.Element[];
  Button: React.FC<{ isActive: boolean }> | JSX.Element;
  color?: string;
  id?: string;
  idDropContainer?: string;
  style?: CSSProperties;
}

// Hook that triggers on clicks outside of the passed ref
const useOutsideAction = (ref: any, action: Function) => {
  useEffect(() => {
    // Action if clicked on outside of element
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        action(false);
      }
    };

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, action]);
};

const DropdownButton = ({
  tooltip = '',
  children,
  Button,
  disabled,
  color,
  id,
  idDropContainer,
  style,
}: DropdownButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<any>(null);
  useOutsideAction(wrapperRef, setIsOpen);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (wrapperRef.current) wrapperRef.current.left = `${e.clientX}px`;
    setIsOpen(!isOpen);
  };

  const checkLeft = (id: string, idDropContainer: string) => {
    const div = document.getElementById(id);
    if (div) {
      const rect = div.getBoundingClientRect();
      const position = window.innerWidth - rect.right + div.offsetWidth;
      const right = window.innerWidth - position + 'px';
      const drop = document.getElementById(idDropContainer);
      if (drop) {
        return right;
      }
    }
  };

  return (
    <Container id={id}>
      <span
        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          !disabled && handleClick(e);
        }}
        title={tooltip}
      >
        {typeof Button === 'function' ? <Button isActive={isOpen} /> : Button}
      </span>
      {
        <DropContainer
          color={color}
          visible={isOpen}
          ref={wrapperRef}
          onClick={() => setIsOpen(false)}
          id={idDropContainer}
          left={id && idDropContainer && checkLeft(id, idDropContainer)}
          style={style}
        >
          {children}
        </DropContainer>
      }
    </Container>
  );
};

export default DropdownButton;
